<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue"

const props = defineProps({
  options: { type: Array, required: true },
  modelValue: { type: String, default: "all" },
  searchPlaceholder: { type: String, default: "Search..." },
})

const emit = defineEmits(["update:modelValue"])

const isOpen = ref(false)
const searchQuery = ref("")
const root = ref(null)

const selectedOption = computed(
  () => props.options.find((option) => option.value === props.modelValue) || props.options[0]
)

const filteredOptions = computed(() => {
  const query = searchQuery.value.toLowerCase().trim()
  if (!query) return props.options
  return props.options.filter((option) => option.label.toLowerCase().includes(query))
})

function toggle() {
  isOpen.value = !isOpen.value
  if (isOpen.value) {
    searchQuery.value = ""
  }
}

function selectOption(option) {
  emit("update:modelValue", option.value)
  isOpen.value = false
}

function onDocumentClick(event) {
  if (!root.value?.contains(event.target)) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener("click", onDocumentClick)
})

onUnmounted(() => {
  document.removeEventListener("click", onDocumentClick)
})
</script>

<template>
  <div ref="root" class="type-filter-dropdown" :class="{ open: isOpen }">
    <button type="button" class="dropdown-toggle" @click="toggle">
      <span class="dropdown-icon">
        <i v-if="selectedOption?.iconClass" :class="selectedOption.iconClass" />
        <img v-else-if="selectedOption?.iconUrl" :src="selectedOption.iconUrl" alt="" class="type-icon">
      </span>
      <span class="dropdown-text">
        <span class="dropdown-label">{{ selectedOption?.label }}</span>
        <span v-if="selectedOption?.count != null" class="dropdown-count">({{ selectedOption.count }})</span>
      </span>
      <i class="bi bi-chevron-down dropdown-arrow" />
    </button>

    <div v-show="isOpen" class="dropdown-menu">
      <div class="dropdown-search">
        <i class="bi bi-search" />
        <input
          v-model="searchQuery"
          type="text"
          class="dropdown-search-input"
          :placeholder="searchPlaceholder"
        >
      </div>

      <div class="dropdown-items">
        <button
          v-for="option in filteredOptions"
          :key="option.value"
          type="button"
          class="dropdown-item"
          :class="{ active: option.value === modelValue }"
          @click="selectOption(option)"
        >
          <span class="item-icon">
            <i v-if="option.iconClass" :class="option.iconClass" />
            <img v-else-if="option.iconUrl" :src="option.iconUrl" alt="" class="type-icon">
          </span>
          <span class="item-label">{{ option.label }}</span>
          <span v-if="option.count != null" class="item-count">{{ option.count }}</span>
        </button>
      </div>
    </div>
  </div>
</template>
